export default {
  comment: [],
  user: [],
};
